export interface ICreateChatMessage {
  game: number
  message: string
}

export interface IChatMessage {
  id: number
  created_at: string
  message: string
  message_type: string
  author: string
  whisper_to: string
  color?: string
  avatar?: string
  whisper_to_avatar?: string
}

export interface IChatMessagePage {
  data: IChatMessage[]
  page: number
  prev?: number
  next: number
  items: number
  totalCount: number
}

export interface ISystemMessage {
  type: string
  arg: string
}

export const chatPageSize = 100
